import PinterestIcon from './pinterest-icon.svg';

export default PinterestIcon;
